<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card class="mx-12 my-12">
          <v-container>
            <v-row class="mx-auto justify-space-around">
              <v-col cols="6">
                <v-img :src="item.imageUrl"/>
              </v-col>
              <v-col cols="6">
                <v-text-field label="标题" readonly dense :value="item.title"/>
                <v-text-field label="SKU" readonly dense :value="item.asin + ' / ' + item.sku"/>
                <v-text-field label="类别" readonly dense :value="item.productGroup + ' / ' + item.productTypeName"/>
                <v-text-field label="零件号: " readonly dense :value="item.partNumber"/>
                <v-text-field label="价格: " readonly dense :value="item.price"/>
                <v-text-field label="尺寸" readonly dense :value="'长: ' + item.length +
          ', 宽: ' + item.width + ', 高: ' + item.height + ', 重量: ' + item.weight + ', 数量: ' + item.packageQuantity
          + ', 大小: ' + item.size" />
                <v-text-field label="Binding" readonly dense :value="item.binding"/>
                <v-text-field label="品牌" readonly dense :value="item.brand"/>
                <v-text-field label="Label" readonly dense :value="item.label"/>
                <v-text-field label="工作室" readonly dense :value="item.studio"/>
                <v-text-field label="制造商" readonly dense :value="item.manufacturer"/>
                <v-text-field label="发布者" readonly dense :value="item.publisher"/>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
      <v-col cols="12">
        <div class="chart mx-12" id="myChart" >
          <div class="emcs_charts" :id="chartId"></div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// 引入highCharts模块
import HighCharts from 'highcharts'

export default {
  name: "ProductDetail",
  data() {
    return {
      chartId: "myChart",
      chart: {
        title: {
          text: !this.title ? "" : this.title
        },
        yAxis: {
          title: {
            text: !this.yTitle ? "" : this.yTitle
          }
        },
        xAxis: {
          categories: []
        },
        series: []
      },
      item: {}
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.$axios.get(this.$format("/products/{0}", this.$route.params.productId)).then(
          response => {
            console.log(response.data);
            this.item = response.data;

            // let xTitles = [];
            if (this.item && this.item.salesRanks && this.item.salesRanks.length > 0) {
              for (let salesRank of this.item.salesRanks) {
                let date = new Date(salesRank.recordTime);
                let str = this.$format("{0}日{1}时", date.getDate(), date.getHours())
                if (this.chart.xAxis.categories.indexOf(str) === -1) {
                  this.chart.xAxis.categories.push(str);
                }
                let found = false;
                for (let tmp of this.chart.series) {
                  if (tmp.name === salesRank.productCategory) {
                    found = true;
                    tmp.data.push(salesRank.curRank);
                    break;
                  }
                }

                if (!found) {
                  this.chart.series.push({name: salesRank.productCategory, data: [salesRank.curRank]});
                }
                // if (salesRanks[salesRank.productCategory]) {
                //   salesRanks[salesRank.productCategory].data.push(salesRank.rank);
                // } else {
                //   salesRanks.push({name: salesRank.productCategory, data: [salesRank.rank]});
                // }
              }
              // this.chart.xAxis.categories = xTitles;
              // this.chart.series = salesRanks;
              console.log(this.chart);

              HighCharts.chart(this.chartId, this.chart);
            }

            // let data;
            //
            //   data = {name: this.item.salesRanks[0].productCategory, data: []};
            // for (let salesRank of this.item.salesRanks) {
            //   let date = new Date(salesRank.recordTime);
            //   this.chart.xAxis.categories.push();
            //   data.data.push(salesRank.rank);
            // }
            // this.chart.series.push(data);
          }
      );
    }
  }
}
</script>

<style scoped>

</style>